/* SpawnAnything — battle bar (user decision 02.10.2026: "fünf große Knöpfe", phone and PC). Five big buttons at the
   bottom: Übernehmen (take over / back to god mode), Werkzeug (the chosen tool; opens the tool belt), Befehl (orders),
   Tempo (pause, slow motion, speed) and Mehr (camera, style, sound, clip, save, setup …). The four groups open as a sheet
   above the buttons. The existing elements (#tools, .formation-bar, #ctrl, #pause, [data-speed], .slowmo-ctl) keep their
   ids, listeners and hidden toggling (main.js / the features show and hide them as before); this module only re-parents
   them. --dock-h (px) tells other bottom HUD bits how much room the bar takes. */
import './dock.css';

const KEY = 'aw-dock-closed';
const $ = s => document.querySelector(s);

export function initDock() {
  const dock = document.createElement('div');
  dock.className = 'aw-dock'; dock.id = 'dock';
  dock.innerHTML = `<div class="aw-sheet" id="dockSheet" hidden></div>
    <button class="aw-dock-handle" type="button" aria-expanded="true" aria-controls="dockBelt" title="Leiste ein-/ausklappen (Taste B)"><span class="aw-dock-arr">▾</span> Leiste</button>
    <div class="aw-quick" id="dockBelt" role="toolbar" aria-label="Kampf">
      <button type="button" data-q="hand"><i class="ti ti-hand-click" aria-hidden="true"></i><span>Übernehmen</span></button>
      <button type="button" data-q="tools" aria-expanded="false"><i class="ti ti-bomb" aria-hidden="true"></i><span>Werkzeug</span></button>
      <button type="button" data-q="orders" aria-expanded="false"><i class="ti ti-flag" aria-hidden="true"></i><span>Befehl</span></button>
      <button type="button" data-q="tempo" aria-expanded="false"><i class="ti ti-player-pause" aria-hidden="true"></i><span>Tempo</span></button>
      <button type="button" data-q="more" aria-expanded="false"><i class="ti ti-dots" aria-hidden="true"></i><span>Mehr</span></button>
    </div>`;
  document.body.appendChild(dock);
  const sheet = dock.querySelector('.aw-sheet'), quick = dock.querySelector('.aw-quick'), handle = dock.querySelector('.aw-dock-handle');
  const qb = k => quick.querySelector(`[data-q=${k}]`);

  /* ---- the four groups become sheet pages ---- */
  const tools = $('#tools'), orders = $('.formation-bar'), ctrl = $('#ctrl');
  const tempo = document.createElement('div'); tempo.className = 'aw-tempo';
  for (const el of [$('#pause'), ...document.querySelectorAll('#ctrl [data-speed]'), $('#ctrl .slowmo-ctl')]) if (el) tempo.appendChild(el);
  // the pause menu for touch (Esc on a keyboard): main menu, restart, settings
  const menuBtn = document.createElement('button'); menuBtn.type = 'button'; menuBtn.className = 'aw-menu-btn';
  menuBtn.innerHTML = '<i class="ti ti-menu-2" aria-hidden="true"></i> Pause-Menü';
  menuBtn.addEventListener('click', () => { close(); document.body.dispatchEvent(new KeyboardEvent('keydown', { code: 'Escape', key: 'Escape', bubbles: true })); });
  const pages = { tools, orders, tempo, more: ctrl };
  for (const [k, el] of Object.entries(pages)) {
    if (!el) continue;
    const wrap = document.createElement('div'); wrap.className = 'aw-page'; wrap.dataset.page = k; wrap.hidden = true;
    wrap.appendChild(el);
    if (k === 'more') wrap.appendChild(menuBtn);
    sheet.appendChild(wrap);
  }
  let open = '';
  function show(k) {
    open = open === k ? '' : k;
    sheet.hidden = !open;
    sheet.querySelectorAll('.aw-page').forEach(p => { if (p.hidden !== (p.dataset.page !== open)) p.hidden = p.dataset.page !== open; });
    quick.querySelectorAll('[data-q]').forEach(b => b.setAttribute('aria-expanded', String(b.dataset.q === open)));
    measure();
  }
  const close = () => { if (open) show(open); };
  quick.addEventListener('click', e => {
    const b = e.target.closest('[data-q]'); if (!b) return;
    const k = b.dataset.q;
    if (k === 'hand') { close(); if ($('#god') && !$('#god').hidden) $('#god').click(); else tools?.querySelector('[data-tool=hand]')?.click(); sync(); return; }
    show(k);
  });
  // a choice in the tool belt or the order bar closes the sheet (the field is free again)
  sheet.addEventListener('click', e => {
    const b = e.target.closest('button'); if (!b) return;
    const pg = b.closest('.aw-page')?.dataset.page;
    if ((pg === 'tools' && b.closest('[data-tool], .hot, .tool-slot')) || pg === 'orders') setTimeout(close, 0);
    setTimeout(sync, 0);
  });
  // Esc closes an open sheet first (capture: before main.js opens the pause menu)
  addEventListener('keydown', e => { if (e.code === 'Escape' && open && e.isTrusted) { e.preventDefault(); close(); } }, true);
  // tapping the field closes an open sheet
  addEventListener('pointerdown', e => { if (open && !dock.contains(e.target) && e.target.id === 'c') close(); }, true);

  /* ---- the big buttons mirror the game: labels, visibility ---- */
  // write only real changes: an unchanged `hidden = true` still queues a mutation record, and the observer below
  // would call sync() again forever
  const hide = (el, v) => { if (el.hidden !== v) el.hidden = v; };
  const text = (el, v) => { if (el.textContent !== v) el.textContent = v; };
  function sync() {
    const god = $('#god') && !$('#god').hidden;
    text(qb('hand').querySelector('span'), god ? 'Gott-Modus' : 'Übernehmen');
    qb('hand').classList.toggle('on', !god && !!tools?.querySelector('[data-tool=hand][aria-pressed=true]'));
    const t = tools?.querySelector('button[aria-pressed=true]:not([data-tool=hand])');
    const name = t ? (t.textContent || '').replace(/^\s*\d\s*/, '').trim() : '';
    text(qb('tools').querySelector('span'), name || 'Werkzeug');
    qb('tools').classList.toggle('on', !!name);
    hide(qb('tools'), !tools || tools.hidden);
    hide(qb('orders'), !orders || orders.hidden);
    const paused = ($('#pause')?.textContent || '').trim() === 'Weiter', sp = $('.slowmo-out')?.textContent || '';
    text(qb('tempo').querySelector('span'), paused ? 'Pausiert' : sp && sp !== '1×' ? sp : 'Tempo');
    const ic = 'ti ' + (paused ? 'ti-player-play' : 'ti-player-pause'), ie = qb('tempo').querySelector('i'); if (ie.className !== ic) ie.className = ic;
    hide(qb('tempo'), !ctrl || ctrl.hidden);
    hide(qb('more'), !ctrl || ctrl.hidden);
    // no battle (setup, replay): no bar
    hide(dock, (!tools || tools.hidden) && (!orders || orders.hidden) && (!ctrl || ctrl.hidden));
    if (open && qb(open)?.hidden) close();
  }
  new MutationObserver(sync).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['hidden', 'aria-pressed'], childList: false });
  for (const el of [$('#pause'), $('.slowmo-out')]) if (el) new MutationObserver(sync).observe(el, { childList: true, characterData: true, subtree: true });

  /* ---- collapse (B) ---- */
  let closed = false;
  try { closed = localStorage.getItem(KEY) === '1'; } catch (e) { /* private mode */ }
  const setClosed = c => {
    closed = c; dock.classList.toggle('closed', c); if (c) close();
    handle.setAttribute('aria-expanded', String(!c)); handle.querySelector('.aw-dock-arr').textContent = c ? '▴' : '▾';
    try { localStorage.setItem(KEY, c ? '1' : '0'); } catch (e) { /* private mode */ }
    measure();
  };
  handle.addEventListener('click', () => setClosed(!closed));
  addEventListener('keydown', e => {
    if ((e.key !== 'b' && e.key !== 'B') || e.ctrlKey || e.metaKey || e.altKey || e.target.closest?.('input,textarea,select,[contenteditable]')) return;
    if (dock.getClientRects().length) setClosed(!closed);
  });

  // room taken at the bottom by the buttons (an open sheet floats above the field and does not move other HUD bits)
  const root = document.documentElement;
  function measure() { const on = dock.getClientRects().length > 0; root.style.setProperty('--dock-h', (on ? (closed ? 0 : quick.offsetHeight) + handle.offsetHeight : 0) + 'px'); }
  new ResizeObserver(measure).observe(quick);
  new MutationObserver(measure).observe(dock, { subtree: true, attributes: true, attributeFilter: ['hidden'] });
  setClosed(closed); sync();

  // multiplayer button: created by the lobby after the features; into the top strip next to the crates
  const top = document.querySelector('header.top'), meta = top && top.querySelector('.meta');
  const moveMp = () => { const b = document.querySelector('.mpbtn:not(.wo-topbtn)'); if (b && top && b.parentElement !== top) { top.insertBefore(b, meta); return true; } return false; };
  if (!moveMp()) { const mo = new MutationObserver(() => { if (moveMp()) mo.disconnect(); }); mo.observe(document.body, { childList: true }); }
  return { dock, setClosed, close };
}
